import { render, staticRenderFns } from "./PaymentOmipayResult.vue?vue&type=template&id=105267a6&scoped=true"
import script from "./PaymentOmipayResult.vue?vue&type=script&lang=js"
export * from "./PaymentOmipayResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105267a6",
  null
  
)

export default component.exports